const NAME = 'buy-your-home';

export default NAME;
